<template>
  <div style="height: 100%;width: 100%">
    <div class="d-flex align-items-center">
      <label class="mx-2 my-auto" for="search-input">جستجو روی نقشه</label>
      <b-form-input
        class="flex-fill w-auto mx-2"
        id="search-input"
        v-model="search"
        placeholder="( جستجو )"
        name="title"
      ></b-form-input>
      <button
        class="btn btn-danger rounded-pill mx-2"
        @click="(e)=>{
        e.preventDefault();
        fetchLocation(search)
        }"
      >
        <i class="fas fa-search"></i> جستجو
      </button>
    </div>
    <div class="text-center my-2">
      <p
        class="text-info"
      >برای جستجو نام خیابان یا منطقه را وارد کنید مثال :(بلوار جمهوری - خیابان مطهری)</p>
    </div>

    <l-map :zoom="zoom" :center="center" :options="mapOptions" @click="handleMapClick" ref="map">
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker :lat-lng="markerLatLng" :icon="icon"></l-marker>

      <l-control position="topleft" class="leaflet-control leaflet-bar">
        <a class="leaflet-bar-part leaflet-bar-part-single" @click="handleCurrentLocation">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </l-control>
    </l-map>
  </div>
</template>

<script>
import { latLng, icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LLayerGroup, LControl } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: "address-map-marker",

  props: ["lat", "lng"],

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControl,
  },
  data() {
    let ll = latLng(
      this.$props.lat ? this.$props.lat : 31.88824775,
      this.$props.lng ? this.$props.lng : 54.36426848300789
    );
    return {
      search: "",
      zoom: 15,
      center: ll,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markerLatLng: ll,
      currentZoom: 15,
      currentCenter: ll,
      mapOptions: {
        zoomSnap: 0.5,
      },
      icon: icon({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("leaflet/dist/images/marker-icon.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        iconSize: [25, 41],
        iconAnchor: [16, 37],
      }),
    };
  },
  methods: {
    handleMapClick(e) {
      this.$emit("changeMarker", e.latlng);

      //this.center = e.latlng;
      this.markerLatLng = e.latlng;
    },

    handleCurrentLocation(e) {
      let $this = this;
      navigator.geolocation.getCurrentPosition(function (location) {
        let latlng = new L.LatLng(
          location.coords.latitude,
          location.coords.longitude
        );

        $this.$emit("changeMarker", latlng);
        $this.markerLatLng = latlng;
        $this.center = latlng;
      });
    },

    fetchLocation(search) {
      this.isLoading = true;
      let $this = this;

      const params = {
        format: "json",
      };

      params["state"] = "یزد";
      params["city"] = "یزد";
      params["street"] = search;

      const queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      //https://nominatim.openstreetmap.org/search.php?street=&city=&county=&state=&country=&postalcode=&polygon_geojson=1&viewbox=
      //https://nominatim.openstreetmap.org/search?q=135+pilkington+avenue,+birmingham&format=json
      //https://nominatim.openstreetmap.org/reverse?lat=31.86150034730701&lon=54.359723925590515&format=json

      //https://maps.googleapis.com/maps/api/geocode/json?address=" + region.latitude + "," + region.longitude + "&key=" + "AIzaSyAhQme3w15EuYxz8zXmE_w7AiDd4rq9QnU"
      //

      fetch("https://nominatim.openstreetmap.org/search.php?" + queryString)
        .then((response) => response.json())
        .then((responseJson) => {
          //const userLocation = responseJson.display_name;
          if (responseJson && responseJson.length > 0) {
            let selectedPlace = null;
            // responseJson.map((place) => {
            //   if (place.type == "town" || place.type == "city") {
            //     selectedPlace = place;
            //     return;
            //   }
            // });

            $this.countries = responseJson;
            $this.isLoading = false;

            // if (selectedPlace == null) {
            //   selectedPlace = responseJson[0];
            // }

            // console.log(selectedPlace);

            // let latlng = new L.LatLng(selectedPlace.lat, selectedPlace.lon);
            // $this.markerLatLng = latlng;
            // $this.center = latlng;

            // latitude: parseFloat(selectedPlace.lat),
            // longitude: parseFloat(selectedPlace.lon),
            // latitudeDelta: region.latitudeDelta,
            // longitudeDelta: region.longitudeDelta,
          }
          //setRegionChangeProgress(false)
        });
    },
  },
  watch: {
    lat: function (newVal, oldVal) {
      this.markerLatLng = latLng(newVal, this.markerLatLng.lng);
      this.center = this.markerLatLng;
    },
    lng: function (newVal, oldVal) {
      // watch it
      this.markerLatLng = latLng(this.markerLatLng.lat, newVal);
      this.center = this.markerLatLng;
    },
  },
};
</script>

<style>

</style>
